<template>
<div>
   
    <footer class="layout-footer">
        <span class="footer-text" style="margin-right: 5px">MC Bot &copy; 2020 - All rights reserved</span>
    
    </footer>
</div>
    
</template>

<script>
   

	export default {
        name: "AppFooter",
     
        data() {
            return {
            
            }
        },
        mounted() {
        
        },
        methods: {
         
        }
	}
</script>

<style scoped>

</style>